import React, { Component } from "react";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return {
    search: state.search
  };
}
class Search extends Component {
  constructor(props) {
    super(props);
    this.onSearch = e => {
      e.preventDefault();
      this.props.dispatch({
        type: "AddSearch",
        payload: e.target.value
      });
    };
  }
  render() {
    return (
      <form className="navbar-form" name="search" onSubmit={this.onSearch}>
        <span className="bmd-form-group">
          <div className="input-group no-border">
            <input
              type="text"
              defaultValue=""
              className="form-control"
              placeholder="Search..."
              name="input"
              onChange={this.onSearch}
            />
            <button
              type="submit"
              className="btn btn-white btn-round btn-just-icon"
            >
              <i className="material-icons">search</i>
              <div className="ripple-container"></div>
            </button>
          </div>
        </span>
      </form>
    );
  }
}
export default connect(mapStateToProps)(Search);
